import { useDataStore } from "@/stores";
import { FormControl, InputLabel, MenuItem, OutlinedInput, Select, SelectChangeEvent } from "@mui/material";

type DownloadVersionDropdownProps = {
    value: string;
    onChange: (event: SelectChangeEvent<string>) => void;
};

const DownloadVersionDropdown = ({ value, onChange }: DownloadVersionDropdownProps) => {
    const versions = useDataStore((state) => state.versions);

    return (
        <FormControl fullWidth size={"medium"} id={"medium"}>
            <InputLabel id="version-dropdown-label">Version</InputLabel>
            <Select
                labelId="version-dropdown-label"
                id="version-dropdown"
                value={value}
                onChange={onChange}
                input={<OutlinedInput label={"Version"} />}
                MenuProps={{
                    PaperProps: {
                        style: {
                            maxHeight: 48 * 4.5 + 8,
                        },
                    },
                }}
                fullWidth
            >
                {versions
                    .sort((a, b) => b.publicationDate.getTime() - a.publicationDate.getTime())
                    .map((x) => (
                        <MenuItem key={x.name} value={x.name}>
                            {x.name}
                        </MenuItem>
                    ))}
            </Select>
        </FormControl>
    );
};

export default DownloadVersionDropdown;
